import React, { useState, useEffect } from "react";
import {
  Card,
  Button,
  Col,
  Container,
  Row,
  Table,
  Modal,
  Alert,
  Tabs,
  Tab,
  Badge,
  Accordion,
} from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import WhatsAppAPI from "../../api/WhatsAppAPI";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link } from "react-router-dom";
import { ShimmerTable } from "../common/ShimmerTable";
import Confirm from "../Confirm";
import moment from "moment";

const CompanyView = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [company, setCompany] = useState(location.state ? location.state : {});
  // const [modalShow, setModalShow] = useState(false);
  const [rowRecords, setRowRecords] = useState();
  const [selectedTab, setSelectedTab] = useState("Invoices");
  const [invoice, setInvoices] = useState([]);
  const [invoiceCheck, setInvoiceCheck] = useState(true);

  const [modalShow, setModalShow] = useState(false);
  const [statusRow, setStatusRow] = useState(undefined);
  const [planById, setPlanById] = useState({});
  const tabs = ["Invoices"];

  const handleMainTab = async (tabname) => {
    try {
      if (tabname === "Invoices") {
        setInvoiceCheck(true);
        setSelectedTab(tabname);
      }
    } catch (error) {
      //    console.log("error=>", error);
    }
  };

  useEffect(() => {
    fetchcompany();
    fetchInvoices();
  }, [statusRow]);

  const fetchcompany = () => {
    if (location.hasOwnProperty("pathname")) {
      company.id = location.pathname.split("/")[2];
    }
    async function init() {
      let result = await WhatsAppAPI.findCompanyWithUser(company.id);
      if (result) {
        setCompany(result.companyResult[0]);
        if (result.companyResult[0].plan_id) {
          const plan = await WhatsAppAPI.getPlansById(
            result.companyResult[0]?.plan_id,
          );
          if (plan) {
            setPlanById(plan);
          }
        }
      } else {
        setCompany({});
      }
    }
    init();
  };

  const editCompany = () => {
    // setModalShow(true);
    setRowRecords(company);
    navigate(`/company/edit/${company.company_id}`, { state: company });
  };

  // const recordSaveSuccesfully = () => {
  //   setModalShow(false);
  //   fetchcompany();
  // };

  const handleBack = () => {
    navigate(`/company`);
  };

  async function fetchInvoices() {
    let result = await WhatsAppAPI.getInvoicesByCompanyId(company.id);
    if (result) {
      let invoiceResponses = [];

      for (let i = 0; i < result.length; i++) {
        const invoice = result[i];
        const response = await WhatsAppAPI.getInvoiceById(invoice.id);

        const addonNames = response
          .filter((item) => item.addon_name)
          .map((item) => item.addon_name);

        if (i === 0) {
          if (addonNames.length > 0) {
            invoice.addon_names = "Plan, " + addonNames.join(", ");
          } else {
            invoice.addon_names = "Plan";
          }
        } else {
          invoice.addon_names =
            addonNames.length > 0 ? addonNames.join(", ") : "N/A";
        }
        invoice.invoice_items = response;
        invoiceResponses.push(invoice);
      }
      setInvoices(invoiceResponses);
    } else {
      setInvoices([]);
    }
  }

  const header = [
    {
      title: "Invoice ID",
      prop: "invoice_no",
      isSortable: true,
      cell: (row) => <Link to={`/invoice/${row.id}`}>ID-{row.invoice_no}</Link>,
    },
    {
      title: "Invoice Date",
      prop: "invoice_date",
      isFilterable: true,
      cell: (row) =>
        row.invoice_date ? moment(row.invoice_date).format("DD-MM-YYYY") : "",
    },
    {
      title: "Plan / Addon Name",
      prop: "addon_names",
      isFilterable: true,
      cell: (row) => (
        <span
          style={{
            maxWidth: "150px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: "inline-block",
            verticalAlign: "middle",
          }}
          title={row.addon_names}
        >
          {row.addon_names}
        </span>
      ),
    },

    {
      title: "Amount",
      prop: "total_amount",
      isFilterable: true,
      cell: (row) => <span>₹{Math.round(row.total_amount)}</span>,
    },
    {
      title: "Status",
      prop: "status",
      isFilterable: true,
      isSortable: true,
      cell: (row) => {
        var badgeColor;
        var value;
        if (row.status === "Complete") {
          badgeColor = "success";
          value = row.status;
        } else if (row.status === "Pending") {
          badgeColor = "danger";
          value =
            new Date() < new Date(row.payment_due_date) ? "Due" : "Over Due";
        } else if (row.status === "Cancel") {
          badgeColor = "warning";
          value = row.status;
        }
        return (
          <>
            <h5>
              <Badge bg={badgeColor} style={{ width: "80px", padding: "6px" }}>
                {value}
              </Badge>
            </h5>
          </>
        );
      },
    },
    ...(invoice.some((row) => row.status === "Pending")
      ? [
          {
            title: "Action",
            prop: "status",
            isFilterable: false,
            cell: (row) => {
              return (
                <>
                  {row.status === "Pending" && (
                    <>
                      <Link to={`/invoice/pay/${row.id}`}>
                        <button className="btn btn-sm mx-2 btn-success">
                          <span>Pay</span>
                        </button>
                      </Link>
                      <Button
                        className="btn-sm mx-2"
                        variant="danger"
                        onClick={() => handleCancelInvoice(row)}
                      >
                        <i className="fa-regular fa-pen-to-square"></i> Cancel
                        Invoice
                      </Button>
                    </>
                  )}
                </>
              );
            },
          },
        ]
      : []),
  ];

  const labels = {
    beforeSelect: " ",
  };

  const handleCancelInvoice = (row) => {
    setStatusRow(row);
    setModalShow(true);
  };

  //edit record
  const handleCancelPay = async () => {
    const editRecord = {
      id: statusRow?.id,
      status: "Cancel",
    };
    let response = {};
    response = await WhatsAppAPI.updateInvoiceRecord(editRecord);
    if (response.success) {
      toast.success(response.message);
      setStatusRow(undefined);
      setModalShow(false);
    } else {
      toast.error(response.message);
    }
  };

  return (
    <>
      <div className="app-view-page">
        <div className="lead-header">
          <div>
            <p className="lead-label">Company</p>
            <h3 className="lead-title">
              {company.company_name || "Company & plan details"}
            </h3>
          </div>
          <div className="lead-actions">
            <Button className="btn-sm btn-back" onClick={handleBack}>
              Back
            </Button>
            <Button
              className="btn-sm btn-edit"
              onClick={() => editCompany(true)}
            >
              Edit
            </Button>
          </div>
        </div>

        <div className="lead-card mt-3">
          <Row className="g-0 view-form">
            <Col lg={12} sm={12} xs={12}>
              <Row className="py-2 ibs-edit-form">
                <Col lg={6} sm={6} xs={6} className="mb-2">
                  <label>Company Name</label>
                  <span className="text-capitalize">
                    {company.company_name ? company.company_name : <>&nbsp;</>}
                  </span>
                </Col>
                <Col lg={6} sm={6} xs={6} className="mb-2">
                  <label>User Name</label>
                  <span className="text-capitalize">
                    {company.firstname ? company.firstname : <>&nbsp;</>}{" "}
                    {company.lastname ? company.lastname : <>&nbsp;</>}
                  </span>
                </Col>
                <Col lg={6} sm={6} xs={6} className="mb-2">
                  <label>Admin Email</label>
                  <span>
                    {company.adminemail ? company.adminemail : <>&nbsp;</>}
                  </span>
                </Col>
                <Col lg={6} sm={6} xs={6} className="mb-2">
                  <label>System Email</label>
                  <span>
                    {company.systememail ? company.systememail : <>&nbsp;</>}
                  </span>
                </Col>
                <Col lg={6} sm={6} xs={6} className="mb-2">
                  <label>Plan</label>
                  <span>
                    {invoice[0]?.plan_name ? (
                      invoice[0]?.plan_name
                    ) : (
                      <>&nbsp;</>
                    )}{" "}
                    ( ₹{invoice[0]?.plan_price})
                  </span>
                </Col>
                <Col lg={6} sm={6} xs={6} className="mb-2">
                  <label>Validity</label>
                  <span className="text-capitalize">
                    {invoice[0]?.validity ? invoice[0]?.validity : <>&nbsp;</>}(
                    {invoice[0]?.planname === "Free Trail"
                      ? "in Days"
                      : "in Months"}
                    ) ({moment(invoice[0]?.start_date).format("DD-MM-YYYY")} —{" "}
                    {moment(invoice[0]?.end_date).format("DD-MM-YYYY")})
                  </span>
                </Col>
                <Col lg={6} sm={6} xs={6} className="mb-2">
                  <label>Number of Users</label>
                  <span>{company.number_of_users}</span>
                </Col>
                <Col lg={6} sm={6} xs={6} className="mb-2">
                  <label>Number of Whatsapp Setting</label>
                  <span>{company.number_of_whatsapp_setting}</span>
                </Col>
                <Col lg={12}>
                  {planById?.modules?.length > 0 && (
                    <div className="my-3">
                      <strong className="mt-4 mb-2">Modules</strong>
                      <Row className="mt-2">
                        {planById.modules.map((module, index) => (
                          <Col md={4} key={module.id}>
                            <i className="fa fa-tasks mx-2"></i>
                            {module.name}
                          </Col>
                        ))}
                      </Row>
                    </div>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </div>

        <Card bg="light" text="light" className="lead-card mt-3 border-0">
          <Card.Header className="d-flex card-header-grey justify-content-between">
            <Tabs
              defaultActiveKey="Invoices"
              id="uncontrolled-tab-example"
              onSelect={(key) => handleMainTab(key)}
            >
              <Tab eventKey="Invoices" title="Invoices"></Tab>
            </Tabs>
          </Card.Header>
          <Card.Body>
            {selectedTab === "Invoices" && (
              <Col lg={12} className="px-4 pb-4">
                {invoice ? (
                  <DatatableWrapper
                    body={invoice}
                    headers={header}
                    paginationOptionsProps={{
                      initialState: {
                        rowsPerPage: 10,
                        options: [5, 10, 15, 20],
                      },
                    }}
                  >
                    <Row className="mb-2 d-flex justify-content-start">
                      <Col
                        lg={3}
                        sm={6}
                        xs={6}
                        className="d-flex flex-col justify-content-start align-items-start"
                      >
                        <Filter />
                      </Col>
                      <Col
                        lg={5}
                        sm={6}
                        xs={6}
                        className="d-flex flex-col justify-content-start align-items-start"
                      ></Col>
                      <Col
                        lg={4}
                        sm={6}
                        xs={6}
                        className="d-flex flex-col justify-content-end align-items-end"
                      >
                        <Link to={"/invoice/generate/" + company.company_id}>
                          <Button className="btn-sm" variant="outline-primary">
                            Generate Invoice
                          </Button>
                        </Link>
                      </Col>
                    </Row>
                    <Table
                      striped
                      className="related-list-table"
                      responsive="sm"
                    >
                      <TableHeader />
                      <TableBody />
                    </Table>

                    <Row className="mb-2">
                      <Col lg={6} sm={12} xs={12}>
                        <Pagination />
                      </Col>
                    </Row>
                  </DatatableWrapper>
                ) : (
                  <ShimmerTable row={10} col={8} />
                )}
              </Col>
            )}
          </Card.Body>
        </Card>
      </div>

      <ToastContainer autoClose={30000} />

      {statusRow && (
        <Confirm
          show={modalShow}
          onHide={() => setStatusRow(undefined)}
          handleCancelPay={handleCancelPay}
          title="Cancel Invoice?"
          message="You are going to update the status to cancel. Are you sure?"
          table="cancel_invoice"
        />
      )}
    </>
  );
};
export default CompanyView;
